import React, { useState } from 'react';
import './entity-selector-item.scss';
import { ListItem } from '../entity-selector';
import CustomIcon, { IconType } from '../../custom-icon/custom-icon';
import { Popover } from 'antd';
import { Column, CrudConfig } from '../../../../model/table';
import { EditorMode } from '../../../../utils/enums';
import { toCamelCase } from '../../../../utils/string-normalization';
import { DataEditorModal } from '../../edit-row-modal/edit-row-modal';

export interface EntitySelectorItemProps<T> {
    item: ListItem;
    onRemove: (item: ListItem) => void;
    EntityLabel: React.FC<{ data: any }>;
    EntityInfo?: React.FC<{ data: any }>;
    crudConfig?: CrudConfig<T>;
    columnsConfig?: Column<T>[];
    fullList?: any[];
    entityName?: string;
    InfoMsg?: React.FC<{ data: any }>;
    removable?: boolean;
}

export const EntitySelectorItem = <T,>({
                                           item,
                                           onRemove,
                                           EntityLabel,
                                           EntityInfo,
                                           crudConfig,
                                           columnsConfig,
                                           fullList,
                                           entityName,
                                           InfoMsg,
                                           removable
                                       }: EntitySelectorItemProps<T>) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);

    const content = EntityInfo ? <EntityInfo data={item.data} /> : null;

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleEditEntityClick = () => {
        setIsPopoverVisible(false);
        setIsModalOpen(true);
    };

    const save = async (editedRowData: T) => {
        await crudConfig?.updateCb?.(editedRowData, item.data);
    };

    return <>
        <Popover
            content={content}
            placement={'right'}
            showArrow={false}
            open={isPopoverVisible}
            overlayClassName={'entity-item-tooltip'}
            trigger={EntityInfo ? 'hover' : ''}
            onOpenChange={(visible) => setIsPopoverVisible(visible)}
        >
            <span className={'entity-selector-item '}>
              <span className={'item-label'}>
                <EntityLabel data={item.data}/>
              </span>
              <div className="item-actions">
                  {crudConfig && columnsConfig && (item.data.isDefault !== true || entityName !== 'Service')  &&
                  <span className={'edit-item-button'}>
                        <CustomIcon type={IconType.PENCIL} onClick={handleEditEntityClick}/>
                  </span>}

                  {removable && <span className={'remove-item-button'}>
                    <CustomIcon type={IconType.CLEAR} onClick={() => onRemove(item)}/>
                    </span>}
              </div>
            </span>
        </Popover>
        {crudConfig && columnsConfig &&
            <DataEditorModal
                isOpen={isModalOpen}
                closeModal={closeModal}
                rowData={item.data}
                columnsConfig={columnsConfig}
                onSave={save}
                crudConfig={crudConfig}
                mode={EditorMode.EDIT}
                header={toCamelCase(`Edit ${entityName}`)}
                okBtnText={'Save'}
                duplicationValidator={crudConfig?.isDuplicated}
                data={fullList || []}
                InfoMsg={InfoMsg}
            />
        }
    </>;
};